export default "__VITE_ASSET__Bgo2z_3j__"